import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ClientConfigService } from "@app/core/config/client-config.service";

@Injectable({
  providedIn: "root"
})
export class RosterService {
  private clientConfigService = inject(ClientConfigService);
  private http = inject(HttpClient);

  public async generateRoster(id: number): Promise<boolean> {
    const config = await this.clientConfigService.config;
    const params = new HttpParams().set("rosterId", id.toString());
    const result = await this.http
      .get(config.serviceUrl + "/api/v1/roster/generate", {
        withCredentials: true,
        params
      })
      .toPromise();
    return result as boolean;
  }
}
